import React, {PureComponent} from 'react';
import Hammer from 'react-hammerjs';
import * as ReactGA from '../../GA';
import HdoSlideOne from './HdoSlideOne';
import HdoSlideTwo from './HdoSlideTwo';
import HdoSlideThree from './HdoSlideThree';
import HdoSlideFour from './HdoSlideFour';
import i18n from '../../locales/i18n';

import './HighDefinitionOpticsClarity.css';

const TITLE = 'high_definition_optics.clarity.title';
const SLIDES = [
    {
        data: {
            label: 'high_definition_optics.clarity.label_1',
            img: require('./clarity-glasses.png'),
            bg: require('./clarity-pitcher.png'),
        },
        component: HdoSlideOne,
    },
    {
        data: {
            label: 'high_definition_optics.clarity.label_2',
            labelHDO: 'high_definition_optics.clarity.label_hdo',
            img: require('./ball-sharp-line.png'),
            bg: require('./clarity-pitcher.png'),
        },
        component: HdoSlideTwo,
    },
    {
        data: {
            label: 'high_definition_optics.clarity.label_3',
            labelHDO: 'high_definition_optics.clarity.label_hdo',
            labelNonHDO: 'high_definition_optics.clarity.label_non_hdo',
            img: require('./ball-sharp.png'),
            img2: require('./ball-blur-line.png'),
            bg: require('./clarity-pitcher.png'),
        },
        component: HdoSlideThree,
    },
    {
        data: {
            label: 'high_definition_optics.clarity.label_4',
            labelHDO: 'high_definition_optics.clarity.label_hdo',
            labelNonHDO: 'high_definition_optics.clarity.label_non_hdo',
            labelLocation: 'high_definition_optics.clarity.label_location',
            img: require('./ball-sharp-line-left.png'),
            img2: require('./ball-location.png'),
            bg: require('./clarity-pitcher.png'),
        },
        component: HdoSlideFour,
    },
];

export default class HighDefinitionOpticsClarity extends PureComponent {
    state = {slide: 0};

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/HighDefinitionOptics/Clarity/${this.state.slide}`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/HighDefinitionOptics/Clarity/${this.state.slide}`
        );
    }

    onSwipe = event => {
        let slide;

        if (event.direction === 2) {
            // last slide
            slide = (this.state.slide + 1) % SLIDES.length;
        }
        if (event.direction === 4) {
            slide = (this.state.slide - 1 + SLIDES.length) % SLIDES.length;
        }
        if (slide != null) {
            this.setState({slide: slide});
        }
    };

    render() {
        const currentSlide = SLIDES[this.state.slide];
        const active = this.state.slide;

        const bullets = SLIDES.map((activeSlide, index) => (
            <div
                key={index}
                className={
                    active === index ? 'bullet bullet--active' : 'bullet'
                }
            />
        ));

        return (
            <Hammer onSwipe={this.onSwipe}>
                <article className="HighDefinitionOpticsClarity">
                    <currentSlide.component
                        data={currentSlide.data}
                        title={TITLE}
                    />
                    <div className="HighDefinitionOpticsClarity-swipe-indicator">
                        <div className="bullets">{bullets}</div>
                    </div>
                </article>
            </Hammer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/highDefinitionOptics/HighDefinitionOpticsClarity.js